<template>
    <b-row class="h-100 bg-grey">
        <b-col cols="3" class="bg-white">
            <div class="pt-4">
                <h2>Create a new app</h2>
                <p>Creating a new app provides API Credentials for Riskhub products and services, as well as features
                    such as OAuth 2.0</p>
                <hr class="my-5">
            </div>

        </b-col>
        <b-col>
            <b-row class="pt-4">
                <b-col cols="6">
                    <b-form>
                        <b-form-group
                                label="Name:"
                                label-size="sm"
                        >
                            <b-form-input
                                    placeholder="App name"
                                    v-model="form.name"
                            ></b-form-input>
                            <div>
                                <small>Name your app based on what role it will fulfill e.g. Contractor App OAuth</small>
                            </div>
                        </b-form-group>

                        <b-btn variant="primary"
                               @click="create"
                               :disabled="form.name.length <= 2">
                            Create
                        </b-btn>
                        <vue-element-loading :active="loading"/>
                    </b-form>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="2">
            <div class="pt-4 d-flex justify-content-end">
                <b-btn :to="{ name: 'apps' }"
                       class="mb-3"
                       variant="primary"
                       size="sm">
                    Back to your apps
                    <font-awesome-icon
                            :icon="['far', 'arrow-right']"
                            class="ml-2">
                    </font-awesome-icon>
                </b-btn>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import Applications from '@/services/Apps/Applications';

export default {
  name: 'Create-App',
  data() {
    return {
      form: {
        name: '',
      },
      loading: false,
    };
  },
  methods: {
    async create() {
      this.loading = true;
      const params = {
        name: this.form.name,
      };

      try {
        const { data } = await Applications.create(params);
        const { applicationId } = data.data;


        await this.$router.push({
          name: 'apps-view',
          params: { id: applicationId },
        });
      } catch (e) {
        this.$notify({
          duration: 5000,
          title: 'Unable to add app',
          text: 'Unable to add app at this time. Please try again later.',
          type: 'error',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
